import PortalIdParser from 'PortalIdParser';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import { HTTP_READY_STATE } from '../../constants/Http';
import { routes } from '../../constants/routes';
import apiAlertMiddleware from './apiAlertMiddleware';
import authenticationAlertMiddleware from './authenticationAlertMiddleware';
import retryMiddleware, { detectRetryMiddleware } from './retryMiddleware';
import skipIntervalRefreshMiddleware from './skipIntervalRefreshMiddleware';
class Client {
  constructor({
    clientStack,
    unauthorizedUrl,
    middlewares,
    accountsUrl,
    acceptanceTestBaseRoute
  }) {
    this.client = promiseClient(createStack(...(middlewares || []), detectRetryMiddleware, authenticationAlertMiddleware({
      unauthorizedUrl: unauthorizedUrl || routes.reconnect,
      accountsUrl: accountsUrl || routes.accounts,
      acceptanceTestBaseRoute: acceptanceTestBaseRoute || routes.acceptanceTestBaseRoute
    }), skipIntervalRefreshMiddleware, apiAlertMiddleware, retryMiddleware, clientStack));
    this.requests = {};
    this.timers = {};
  }
  post(url, options) {
    return this.makeRequest({
      url,
      options,
      method: 'post'
    });
  }
  get(url, options) {
    return this.makeRequest({
      url,
      options,
      method: 'get'
    });
  }
  put(url, options) {
    return this.makeRequest({
      url,
      options,
      method: 'put'
    });
  }
  patch(url, options) {
    return this.makeRequest({
      url,
      options,
      method: 'patch'
    });
  }
  delete(url, options) {
    return this.makeRequest({
      url,
      options,
      method: 'delete'
    });
  }
  options(url, options) {
    return this.makeRequest({
      url,
      options,
      method: 'options'
    });
  }
  setPortalToUrl(value) {
    const portalId = PortalIdParser.getPortalIdFromPath();
    if (!portalId) return value;
    const [url, params] = value.split('?');
    return `${url}?portalId=${portalId}${params ? `&${params}` : ''}`;
  }
  makeRequest({
    url,
    options,
    method
  }) {
    const key = `${method}${url.split('?')[0]}`;
    const urlWithPortal = this.setPortalToUrl(url);
    this.checkForPendingRequest(key);
    if (options && options.delay) {
      const delay = options.delay;

      // delete delay property to prevent pollution request body
      // as this param is need to our internal needs
      delete options.delay;
      return new Promise(resolve => {
        const timer = setTimeout(() => {
          delete this.timers[key];
          resolve(this.client[method](urlWithPortal, Object.assign({}, options, {
            withXhr: xhr => {
              this.handleRequest({
                request: xhr,
                key
              });
            }
          })));
        }, delay);
        this.timers[key] = timer;
      });
    } else {
      return this.client[method](urlWithPortal, Object.assign({}, options, {
        withXhr: xhr => {
          this.handleRequest({
            request: xhr,
            key
          });
        }
      }));
    }
  }

  // check if there pending timeout or request
  checkForPendingRequest(key) {
    const currentTimer = this.timers[key];
    const currentRequest = this.requests[key];
    if (currentTimer) {
      clearTimeout(currentTimer);
      delete this.timers[key];
    }
    if (currentRequest) {
      currentRequest.abort();
      delete this.requests[key];
    }
  }

  // save request locally
  // point is to cancel request if new same comes
  // after request done it`s ready state is equal 4 and we remove it
  handleRequest({
    request,
    key
  }) {
    this.checkForPendingRequest(key);
    this.requests[key] = request;
    request.onreadystatechange = () => {
      const requestToCheck = this.requests[key];
      if (requestToCheck && requestToCheck.readyState === HTTP_READY_STATE.DONE) {
        delete this.requests[key];
      }
    };
  }
}
export default Client;